import { render, staticRenderFns } from "./UserRolesEdit.vue?vue&type=template&id=4d389cd5"
import script from "./UserRolesEdit.vue?vue&type=script&lang=ts"
export * from "./UserRolesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports